import { FC, useMemo } from "react";
import { useExerciseState } from "@/contexts/exercise/Context";
import { getExercisesOptions } from "../Desktop/WarmUp";
import { ExerciseTODO, WarmUpProps } from "@/types";
import Button from "@edusogno/primitives/button";
import CheckGreen from "@/components/icons/CheckGreen";
import ExerciseTrack from "./ExerciseTrack";
import ExercisesContainer from "@/contexts/exercise/Container";

const WarmUpMobile: FC<WarmUpProps & { onStart: () => void }> = ({
  onStart,
  exercise,
}) => {
  const { isExerciseStarted, exerciseResults } = useExerciseState();

  const exerciseTrack = exercise?.text || "";
  const audioUrl = exercise?.audio_file || "";
  const imageUrl = exercise?.img_file || "";
  const exerciseType = exercise?.modality.toLowerCase() || "";
  const definitions = exercise?.definitions || [];

  const exercisesOptions = useMemo(
    () => getExercisesOptions(exercise),
    [exercise],
  );

  const doneArray = useMemo(
    () => exerciseResults?.map((e) => e.type),
    [exerciseResults],
  );

  return (
    <div className="flex flex-col justify-between text-xl font-semibold leading-6 text-black gap-2 h-full">
      <div className="w-full placeholder:flex flex-col justify-start items-center gap-2">
        <div className="justify-center bg-[#D9D9D9] mb-4 rounded-lg overflow-auto [&::-webkit-scrollbar]:w-0 h-auto">
          <ExerciseTrack
            audioUrl={audioUrl}
            imageUrl={imageUrl}
            definitions={definitions}
            exerciseType={exerciseType}
            exerciseTrack={exerciseTrack}
            exerciseStarted={isExerciseStarted}
          />
        </div>

        {isExerciseStarted ? (
          <ExercisesContainer exercise={exercise as ExerciseTODO} />
        ) : (
          <div className="mt-1">
            {exercisesOptions.map(({ id, Icon, title, description, type }) => {
              const isDone = (doneArray as Array<string>).includes(type);

              return (
                <div
                  key={id}
                  className="flex justify-between items-center bg-white rounded-[5px] px-4 mb-1"
                >
                  <div className="flex items-center">
                    <Icon className="w-[20px] min-w-[20px] h-[20px] mr-2" />

                    <div className="py-2">
                      <h2 className="text-[12px] font-bold">{title}</h2>

                      <p className="text-[10px] leading-[10px] text-gray-500">
                        {description}
                      </p>
                    </div>
                  </div>

                  {isDone && (
                    <div className="md:w-4 md:h-4 flex items-center justify-center bg-shade-five rounded-[3px]">
                      <CheckGreen />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {!isExerciseStarted && (
        <Button
          onClick={onStart}
          variant="outlined"
          className="mt-1 bg-brand-secondary text-white font-semibold w-full py-2 rounded-[10px]"
        >
          Start
        </Button>
      )}
    </div>
  );
};

export default WarmUpMobile;
